class MainProduct extends HTMLElement {
  form; loader; productData; 
  static s = {
    add: '[data-add]',
    variant: '[data-change-variant]',
    checkout: '[data-checkout]'
  }
  constructor() {
    super();
    this.loader = document.querySelector('theme-loader[data-global]');
    window.addEventListener(Utils.E_CART_ADDED, () => this.reload(location.href));
    window.addEventListener(Utils.E_CART_REMOVED, () => this.reload(location.href));
    window.addEventListener(Utils.E_CART_UPDATED, () => this.reload(location.href));
    this.init();
  }

  init = () => {
    this.form = this.querySelector('form');
    this.productData = JSON.parse(this.querySelector('#product-json').innerText);
    this.querySelectorAll(MainProduct.s.add).forEach(button => {
      button.addEventListener('click', () => this.addToCart());
    });
    this.querySelectorAll(MainProduct.s.variant).forEach(button => {
      button.addEventListener('click', (e) => this.changeVariant(e, button));
    });
    this.querySelectorAll(MainProduct.s.checkout).forEach(button => {
      button.addEventListener('click', () => this.purchase());
    });
  }

  changeVariant = (e, button) => {
    e.preventDefault();
    const url = button.getAttribute('href');
    this.reload(url);
  }

  reload = (url) => {
    axios.get(url).then((response) => {
      this.reloaded(response, url);
    }).catch((error) => {
      Utils.errorHandler({
        message: error.response.data.message || error.message,
        target: 'product-reload',
        error: error,
        type: 'axios'
      });
    });
  }

  reloaded = (response, url) => {
    const doc = Utils.getDocument(response.data);
    const product = doc.querySelector('main-product');
    if(product) {
      this.innerHTML = product.innerHTML;
    }
    window.history.replaceState({}, '', url);
    this.init();
    this.apps();
  }

  apps = () => {
    this.feedaty();
  }

  feedaty = () => {
    const script = document.querySelector('#qa-script');
    if(script){
      const newScript = script.cloneNode();
      script.remove();
      document.body.appendChild(newScript);
    }
    FeedatyWidget.init();
    feedatyQaInit();
  }

  addToCart = () => {
    this.showLoader();
    Utils.addTocart({
      form: this.form,
      finally: () => this.hideLoader()
    });
  }

  purchase = () => {
    this.showLoader();
    Utils.addTocart({
      data: new FormData(this.form),
      success: () => {
        window.location.href = Shopify.routes.root + 'checkout';
      }
    });
  }

  showLoader = () => {
    if(this.loader)
      this.loader.show();
  }

  hideLoader = () => {
    if(this.loader)
      this.loader.hide();
  }
}
if(!customElements.get('main-product')) {
  customElements.define('main-product', MainProduct);
}

class ProductSticky extends HTMLElement {
  static hiddenClasses = ['invisible'];

  show = () => {
    ProductSticky.hiddenClasses.forEach(className => {
      this.classList.remove(className);
    });
  }

  hide = () => {
    ProductSticky.hiddenClasses.forEach(className => {
      this.classList.add(className);
    });
  }
}
if(!customElements.get('product-sticky')) {
  customElements.define('product-sticky', ProductSticky);
}

class ProductButtons extends HTMLElement {
  productSticky;

  connectedCallback(){
    this.productSticky = document.querySelector('product-sticky');
    this.init();
  }

  init = () => {
    if(this.productSticky != undefined){
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.productSticky.hide();
          } else if(entry.boundingClientRect.top < 0) {
            this.productSticky.show();
          }
        });
      });
      observer.observe(this);
    }
  }
}
if(!customElements.get('product-buttons')) {
  customElements.define('product-buttons', ProductButtons);
}

//gestisce il trova in negozio in pp con onestock
class StoreStock extends HTMLElement {

  i18n;     // traduzioni
  province; // la provincia del cliente (sigla)
  zip;      // il cap del cliente 
  stores;   // elenco sedi
  stocks;   // risposta di onestock per la variante
  merged;   // elenco dei negozi con relativa disponibilità
  store;    // id dello store preferito
  unified;  // sede unified dall'elenco merged

  static S = {
    saveProvince: '[data-province-save]',
    provinceInput: '#store-province-input',
    deliveryTitle: '[data-delivery-title]',
    deliveryDescription: '[data-delivery]',
    storeList: '[data-store-list]',
    storeTitle: '[data-store-title]',
    storeInner: '[data-store]',
    storeItem: '[data-store-item]'
  }
  static UNIFIED = 'XY'; // codice dello store unified
  static URLSTORES = `${Utils.API_URL}/api/fidelity/shops`;
  static URLSTOCK = `${Utils.API_URL}/api/shop/${Shopify.shop}/product-stocks-by-sku-codes`;
  static MAP_API = 'AIzaSyDzJfY1o0dk-bSGQPKFiur1uBzt2TjVYRE';

  connectedCallback() {
    this.i18n = JSON.parse(this.dataset.i18n);

    this.addEventListener(Utils.E_STORES, () => {
      this.merge();
    });
    this.addEventListener(Utils.E_STORE_STOCK, () => {
      this.merge();
    });
    this.addEventListener(Utils.E_STORE_MERGED, () => {
      this.getProvince();
      this.showStores();
    });
    this.addEventListener(Utils.E_STORE_PROVINCE, () => {
      this.getStore();
      this.showProvince();
      this.fillZipInput();
    });
    this.addEventListener(Utils.E_STORE_FOUND, () => {
      this.showStore();
    });
    
    this.getStores();
    this.getStocks();
    this.handleProvince();
  }

  // trova la provincia geolocalizzando o controllando se è salvata nel localStorage o se la ha nei dataset
  getProvince = () => {
    this.province = this.dataset.province || localStorage.getItem('province');
    this.zip = this.dataset.zip || localStorage.getItem('zip');
    if(!this.province){
      if(navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          const latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          this.geocode({ 'latLng': latlng });
        });
      } else {
        console.log('stock error');
      }
      this.getStore();
    } else {
      localStorage.setItem('province', this.province);
      this.dispatchEvent(new CustomEvent(Utils.E_STORE_PROVINCE, { detail: this.province }));
    }
  }

  // trova lo store preferito o lo cerca tra quelli della provincia
  getStore = () => {
    this.store = localStorage.getItem('favourite_shop');
    if(this.store) {
      this.dispatchEvent(new CustomEvent(Utils.E_STORE_FOUND, { detail: this.store }));
    } else if(this.province) {
      this.store = this.stores.find(store => store.address?.provinceCode == this.province)?.shop_id.value;
      if(this.store) {
        localStorage.setItem('favourite_shop', this.store);
      }
      this.dispatchEvent(new CustomEvent(Utils.E_STORE_FOUND, { detail: this.store }));
    }
  }

  // ottiene tutti i negozi o dal sessionStorage o dal server
  getStores = () => {
    this.stores = JSON.parse(sessionStorage.getItem('stores'));
    if(!this.stores) {
      axios({
        url: StoreStock.URLSTORES,
        method: 'get',
        withCredentials: true
      })
      .then((response) => {
        this.stores = response.data;
        sessionStorage.setItem('stores', JSON.stringify(this.stores));
        this.dispatchEvent(new CustomEvent(Utils.E_STORES, { detail: this.stores }));
      }).catch((error) => {
        Utils.errorHandler({
          message: error.message,
          target: 'store-stock',
          error: error,
          type: 'axios'
        });
      });
    } else {
      this.dispatchEvent(new CustomEvent(Utils.E_STORES, { detail: this.stores }));
    }
  }

  // ottiene le disponibilità della variante da onestock e pubblica un evento al success
  getStocks = () => {
    axios({
      url: StoreStock.URLSTOCK,
      method: 'post',
      data: JSON.stringify(this.dataset.sku.split(',')),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      this.stocks = response.data;
      this.dispatchEvent(new CustomEvent(Utils.E_STORE_STOCK, { detail: this.stocks }));
    }).catch((error) => {
      Utils.errorHandler({
        message: error.message,
        target: 'store-stock',
        error: error,
        type: 'axios'
      });
    });
  }

  // popola l'elenco merged con le disponibilità
  merge = () => {
    if(this.stores && this.stocks) {
      this.merged = this.stores.map(store => {
        const stock = this.stocks.find(stock => stock.storeCode == store.shop_id.value);
        return {
          ...store,
          stock: stock
        }
      });
      this.unified = this.merged.find(store => store.shop_id.value == StoreStock.UNIFIED);
      this.dispatchEvent(new CustomEvent(Utils.E_STORE_MERGED, { detail: this.merged }));
    }
  }

  // mostra la provincia selezionata e la disponibilità di consegna
  showProvince = () => {
    if(this.province && this.unified){
      const deliveryTitle = this.querySelector(StoreStock.S.deliveryTitle);
      if(deliveryTitle){
        deliveryTitle.innerText = this.i18n.delivery_to.replace('{{ province }}', this.zip);
      }
      const deliveryDescription = this.querySelector(StoreStock.S.deliveryDescription);
      if(deliveryDescription){
        const type = this.unified.stock?.quantity > 0 ? (this.unified.stock.quantity < 3 ? 'low-stock' : 'available') : 'unavailable';

        if(type == 'available') {
          this.getDelivery(deliveryDescription);
          return;
        }

        if(type == 'low-stock') {
          this.getDelivery2(deliveryDescription);
          return;
        }

        const template = this.getTemplate(type);
        deliveryDescription.innerHTML = template.innerHTML;
      }
    }
  }

    getDelivery2 = (deliveryDescription) => {
    const json = JSON.parse(this.querySelector('[data-shipping').innerText);
    const template = this.getTemplate('low-stock');
    const filtered = json.filter(r => r.country.toUpperCase() == this.dataset.country && r.min <= r.product_price && r.max >= r.product_price);

  // ORDINA prima Standard, poi Express, poi il resto
  filtered.sort((a, b) => {
    const priority = name => {
      if (name === "Standard") return 0;
      if (name === "Express") return 1;
      return 2;
    };
    return priority(a.name) - priority(b.name);
  });
    
    const deliveries = filtered.map(delivery => {
      return this.calcDelivery(delivery);
    });
    deliveryDescription.innerHTML = template.innerHTML.replaceAll('{delivery}', deliveries.join(''));
  }

  getDelivery = (deliveryDescription) => {
    const json = JSON.parse(this.querySelector('[data-shipping').innerText);
    const template = this.getTemplate('available');
    const filtered = json.filter(r => r.country.toUpperCase() == this.dataset.country && r.min <= r.product_price && r.max >= r.product_price);

  // ORDINA prima Standard, poi Express, poi il resto
  filtered.sort((a, b) => {
    const priority = name => {
      if (name === "Standard") return 0;
      if (name === "Express") return 1;
      return 2;
    };
    return priority(a.name) - priority(b.name);
  });
    
    const deliveries = filtered.map(delivery => {
      return this.calcDelivery(delivery);
    });
    deliveryDescription.innerHTML = template.innerHTML.replaceAll('{delivery}', deliveries.join(''));
  }

  calcDelivery = (delivery) => {
    const template = this.getTemplate('delivery');
    const price = Number(delivery.price);
    const priceString = price > 0 ? Utils.money(price) : this.i18n.stock.free;
    const from = this.calcDeliveryDate(delivery.from);
    const to = this.calcDeliveryDate(delivery.to);

    // Mostra solo se il prezzo è "gratis"
    const showPrice = priceString === this.i18n.stock.free ? ` (${priceString})` : '';
    
    return template.innerHTML
      .replaceAll('{name}', delivery.name)
      .replaceAll('{from}', from)
      .replaceAll('{to}', to)
      .replaceAll('{price}', showPrice);
  }

  calcDeliveryDate = (days) => {
    let date = new Date();
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) { // 0 = Sunday, 6 = Saturday
        added++;
      }
    }
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${day}/${month}`;
  }

  // mostra la disponibilità nello store selezionato
  showStore = () => {
    if(this.merged && this.store){
      console.log('store', this.store);
      const store = this.merged.find(store => store.shop_id.value == this.store);

      const storeTitle = this.querySelector(StoreStock.S.storeTitle);
      const storeInner = this.querySelector(StoreStock.S.storeInner);

      storeTitle.innerText = store.name;
      const template = this.getTemplate('store-stock').innerHTML;
      var onlineTemplate, storeTemplate;

      if(store.stock?.quantity > 0) {
        if(store.stock.quantity >= 2){
          onlineTemplate = this.getTemplate('online-available').innerHTML.replaceAll('{text}', this.i18n.online_store.store_available);
          storeTemplate = this.getTemplate('store-available').innerHTML;
        } else{
          onlineTemplate = this.getTemplate('online-available').innerHTML.replaceAll('{text}', this.i18n.online_store.store_low);
          storeTemplate = this.getTemplate('store-low').innerHTML;
        }
      } else {
        storeTemplate = this.getTemplate('store-unavailable').innerHTML;
        if(this.unified?.stock.quantity >= 3) {
          onlineTemplate = this.getTemplate('online-available').innerHTML.replaceAll('{text}', this.i18n.online_store.unified_available);
        } else if(this.unified?.stock.quantity > 0) {
          onlineTemplate = this.getTemplate('online-low').innerHTML;
        } else {
          onlineTemplate = this.getTemplate('online-unavailable').innerHTML;
        }
      }
      storeInner.innerHTML = template.replaceAll('{online}', onlineTemplate).replaceAll('{store}', storeTemplate);
    }
    

  }

  // mostra i negozi nell'offcanvas e gestisce il click
  showStores = () => {
    if(this.merged) {
      const list = this.querySelector(StoreStock.S.storeList);
      if(list){
        this.merged.filter(store => store.shop_id.value != StoreStock.UNIFIED).forEach(store => {
          const template = this.getTemplate('store-item');
          list.innerHTML += template.innerHTML
            .replaceAll('{id}', store.shop_id.value)
            .replaceAll('{name}', store.name)
            .replaceAll('{address}', `${store.address.address1}<br>${store.address.zip} ${store.address.city} (${store.address.provinceCode})`);
        });
        this.querySelectorAll(StoreStock.S.storeItem).forEach(item => {
          item.addEventListener('click', () => {
            this.store = item.dataset.storeItem;
            localStorage.setItem('favourite_shop', this.store);
            this.dispatchEvent(new CustomEvent(Utils.E_STORE_FOUND, { detail: this.store }));
          });
        });
      }
    }
  }

  // gestisce la input di selezione della provincia
  handleProvince = () => {
    const button = this.querySelector(StoreStock.S.saveProvince);
    button.addEventListener('click', () => {
      const input = this.querySelector(StoreStock.S.provinceInput);
      if(input.value.trim() != this.zip){
        this.geocode({ address: input.value });
      } else {
        this.showError();
      }
      this.dispatchEvent(new CustomEvent(Utils.E_STORE_PROVINCE, { detail: this.province }));
    });
  }

  // geolocalizza in base a data e restituisce la provincia e il cap
  geocode = (data) => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode(data, (results, status) => {
      if(status === google.maps.GeocoderStatus.OK){
        this.province = results[0].address_components.find(component => {
          return component.types.includes('administrative_area_level_2');
        });
        this.zip = results[0].address_components.find(component => {
          return component.types.includes('postal_code');
        });
        this.province = this.province?.short_name;
        this.zip = this.zip?.short_name;
        if(this.province && this.zip) {
          localStorage.setItem('province', this.province);
          localStorage.setItem('zip', this.zip);
          this.dispatchEvent(new CustomEvent(Utils.E_STORE_PROVINCE, { detail: this.province }));
        } else {
          this.showProvinceError();
        }
      } else {
        this.showProvinceError();
      }
    });
  }

  showProvinceError = () => {
    Utils.errorHandler({
      message: this.i18n.province.error,
      target: 'store-stock',
      type: 'province',
      popup: true
    })
  }

  // ottiene il template che si desidera
  getTemplate = (name) => {
    return this.querySelector(`template[name="${name}"]`);
  }

  // mostra il cap selezionato di default
  fillZipInput = () => {
    const input = this.querySelector(StoreStock.S.provinceInput);
    if(input && this.zip){
      input.value = this.zip;
    }
  }


}
if(!customElements.get('store-stock')) {
  customElements.define('store-stock', StoreStock);
}

class StoqBtn extends HTMLElement {
  productData;

  connectedCallback() {
    this.productData = JSON.parse(document.querySelector('#product-json')?.innerText);
    if(!this.productData || !this.productData.variant || !this.productData.variant.id || !this.productData.product) {
      console.error("StoqBtn: No product data found.");
      return;
    }

    this.addEventListener('click', this.openStoq.bind(this));
  }

  openStoq = () => {
    if(!window._RestockRocket) {
      console.error("StoqBtn: RestockRocket is not loaded.");
      return;
    }
    window._RestockRocket.openModal(this.productData.product, this.productData.variant.id);
    window.dispatchEvent(new CustomEvent(Utils.E_BACKSTOCK));
    Shopify.analytics.publish(Utils.E_BACKSTOCK);
  }
}
if(!customElements.get('stoq-btn')) {
  customElements.define('stoq-btn', StoqBtn);
}